import classNames from 'classnames';
import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';
import React from 'react';
import { FormControlProps } from 'react-bootstrap/FormControl';
import { DecoratedFormUnit } from '../../base/DecoratedFormUnit';
import { BsForm, InputProps, parseInputProps } from '../../base/Form';

type Props = InputProps & object;

export function TimeInputP(props: Props) {
  const { inputProps, unitProps } = parseInputProps(props);

  return (
    <DecoratedFormUnit {...unitProps}>
      <BsForm.Control
        type="time"
        isInvalid={!!unitProps.error}
        {...(inputProps as FormControlProps)}
        className={classNames(inputProps.className, 'text-center')}
      />
    </DecoratedFormUnit>
  );
}

export const TimeInput = TimeInputP;

export function TimeField(props: React.ComponentProps<typeof TimeInput>) {
  const { name, ...rest } = props;

  return (
    <Field name={name}>
      {(fp: FieldProps) => {
        return (
          <TimeInput
            {...fp.field}
            {...rest}
            error={fp.meta.touched && fp.meta.error}
            disabled={rest.disabled}
            // readOnly={fp.form.isSubmitting}
          />
        );
      }}
    </Field>
  );
}
